<script lang="ts">
  import type { ComponentType } from 'svelte';
  import ArrowIcon from '$lib/assets/icons/ArrowIcon.svelte';
  import ViewAllLink from './ViewAllLink.svelte';
  import { sendAnalyticsEvent } from '$lib/services/analytics';
  import { EventNames, EventSectionName } from '$lib/types/analytics';

  export let title: string;
  export let link = '';
  export let color = 'var(--color-title)';
  export let viewAllColor = 'var(--color-text-secondary)';
  export let sectionName: EventSectionName | '' = '';
  export let viewAllIcon: ComponentType = ArrowIcon;

  const handleClick = () => {
    sendAnalyticsEvent(EventNames.CLICK_CARD, {
      cta: 'View All',
      section_name: sectionName,
      description: title
    });
  };
</script>

<div class="container">
  <h2 class="header" style="--text-color: {color}">{title}</h2>
  {#if link}
    <ViewAllLink href={link} color={viewAllColor} {viewAllIcon} {handleClick} />
  {/if}
</div>

<style lang="scss">
  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-left: 3px solid #fc024d;
    padding-left: 12px;
    // padding-right: 14px;
  }

  .header {
    font-weight: var(--font-weight-semibold);
    font-size: var(--font-size-base);
    color: var(--text-color);
    margin: 0;
  }
</style>
